import { PlayCircleOutlined } from "@ant-design/icons";
import { Image } from "antd";
import React from "react";
import { isImageUrl } from "utils/urlUtils";

type ThumbnailDragOverlayProps = {
  activeId: string | null;
  mediaUrls: string[];
};

const ThumbnailDragOverlay: React.FC<ThumbnailDragOverlayProps> = ({
  activeId,
  mediaUrls,
}) => {
  if (!activeId) {
    return null;
  }

  const activeIndex = mediaUrls.findIndex(
    (_, index) => `media-${index}` === activeId
  );
  if (activeIndex === -1) {
    return null;
  }

  const activeUrl = mediaUrls[activeIndex];
  const isImage = isImageUrl(activeUrl);

  return (
    <div className="w-[100px] h-[100px] rounded overflow-hidden relative group opacity-75 shadow-lg">
      {isImage ? (
        <Image
          src={activeUrl}
          alt="Dragging thumbnail"
          width={100}
          height={100}
          preview={false}
          className="object-cover w-full h-full"
        />
      ) : (
        <div className="relative w-[100px] h-[100px]">
          <video
            src={activeUrl}
            muted
            width={100}
            height={100}
            className="object-cover w-full h-full rounded"
            preload="metadata"
          />
          <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 pointer-events-none">
            <PlayCircleOutlined className="text-white text-2xl" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ThumbnailDragOverlay;
